<template>

  <div class="donut" :style="{'background-image': setBgIcon()}">
    <div class="donut-hc" :id="`donut-chart-${percentages.img}`"></div>
  </div>

</template>

<script>
import VueHighcharts from 'vue-highcharts';
import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';
More(Highcharts);
import cToF from 'celsius-to-fahrenheit';

export default {
  data(){
    return {

    }
  },
  props: ['percentages', 'child'],
  methods: {
    setBgIcon(){
      return this.percentages.img != 'on'
        ? `url(https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${this.percentages.img}.png)`
        : `url(${require('@/assets/off.png')})`;
    },
    setPieData(){
      if (this.percentages.img == 'on') {
        return [['HVAC ON', 39], ['HVAC OFF', 61]];
      } else {
        return ['good', 'bad', 'crit'].map(tier => {
          return [tier[0].toUpperCase() + tier.substring(1, tier.length), this.percentages[tier]]
        })
      }
    },
    mountChart(){
      const chart = {
        chart: {
          type: 'pie',
          backgroundColor: null,
          spacingTop: 0,
          spacingBottom: 0,
          spacingLeft: 0,
          spacingRight: 0
        },
        title: null,
        plotOptions: {
          pie: {
            shadow: false,
            size: '90%',
            borderWidth: 0
          }
        },
        series: [{
          size: '90%',
          innerSize: '70%',
          data: this.setPieData(),
          dataLabels: {
            enabled: false
          }
        }],
        colors: ['#71C076', 'yellow', '#ff002d'],
        credits: {
          enabled: false
        }
      };
      try {
        this.target = Highcharts.chart('donut-chart-' + this.percentages.img, chart);
      } catch(err) {
        console.log({CUSTOM_HIGHCHARTS_ERROR: err});
      }
    }
  },
  mounted(){
    setTimeout(() => this.mountChart(), 1000);
  }
}


</script>

<style>

.donut {
  width: 100%;
  height: 100%;
  max-height: 185px;
  max-width: 185px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #325468;
  border-radius: 4px;
  background-repeat: no-repeat;
  background-size: 40px;
  background-position: center;
  border: 3px solid rgb(0, 153, 191);
}

.donut-hc {
  width: 100%;
  height: 100%;
  background: none;
}

</style>



// WEBPACK FOOTER //
// src/components/report/Donut.vue